var map = {
	"./de/1.png": "584b",
	"./de/10.png": "02ee",
	"./de/11.png": "8c8c",
	"./de/12.png": "0765",
	"./de/2.png": "fce4",
	"./de/3.png": "8a0f",
	"./de/4.png": "aca2",
	"./de/5.png": "3cfe",
	"./de/6.png": "c7fb",
	"./de/7.png": "7efb",
	"./de/8.png": "8314",
	"./de/9.png": "d59b",
	"./en/1.png": "4f80",
	"./en/10.png": "88e4",
	"./en/11.png": "0e4c",
	"./en/12.png": "679a",
	"./en/2.png": "ce7d",
	"./en/3.png": "bc08",
	"./en/4.png": "83d6",
	"./en/5.png": "1c1f",
	"./en/6.png": "9124",
	"./en/7.png": "598a",
	"./en/8.png": "31b9",
	"./en/9.png": "9d8b",
	"./fr/1.png": "3e72",
	"./fr/10.png": "6a526",
	"./fr/11.png": "6c84",
	"./fr/12.png": "a318",
	"./fr/2.png": "e931",
	"./fr/3.png": "e162",
	"./fr/4.png": "7c56",
	"./fr/5.png": "4b5a",
	"./fr/6.png": "fca3",
	"./fr/7.png": "82d2",
	"./fr/8.png": "a873",
	"./fr/9.png": "0831",
	"./it/1.png": "0a5d",
	"./it/10.png": "5588",
	"./it/11.png": "a595",
	"./it/12.png": "af4f",
	"./it/2.png": "25a8",
	"./it/3.png": "ec77",
	"./it/4.png": "f535",
	"./it/5.png": "9fd3",
	"./it/6.png": "f3e9",
	"./it/7.png": "be08",
	"./it/8.png": "e1b5",
	"./it/9.png": "8be6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2826";